<div *ngIf="systemMessages && systemMessages.length && !this.closed" class="d-flex justify-content-center">
  <!--<button class="clear" (click)="messageService.clear()">clear</button>-->
  <div *ngFor='let message of systemMessages; index as i'>
    <ngb-alert *ngIf="i === systemMessages.length-1"  [type]="'danger'" role="alert" (close)="this.closed = true">
      <i class="fas fa-exclamation-triangle color-red"></i><strong> {{message}}</strong> 
    </ngb-alert>
  </div>
</div>
